import { LitElement, html, css } from 'lit';
import { accessibility, grid } from '../../utilities/styles';
import { cardLinks } from '../../utilities/accessibility';
import { getStatus } from '../../utilities/orgUtilities';
import { decodeEntities, checkFormLock } from '../../utilities/formsUtilities';
import { AllInSessionStorage } from '../Utilities/AllInSessionStorage';
import { AllInConditionals } from '../Utilities/AllInConditionals';
import { AllInOrganisationConsumer } from '../Utilities/AllInOrganisationConsumer';
//import arrowUrl from '../../../../../../assets/arrow.svg?url';
export class AllInOrganisationSupportProfiles extends AllInConditionals(AllInSessionStorage(AllInOrganisationConsumer(LitElement))) {
    static properties = {
        ...super.properties,
        _loading: { state: true, type: Boolean },
        _supportData: { state: true, type: Array },
        _isApproved: { state: true, type: Boolean },
        //_hasZones: {state:true,type: Boolean},
    };
    constructor() {
        super();
        this._loading = true;
        //this._hasZones = true;
    }
    async connectedCallback() {
        super.connectedCallback();
        this._loading = true;
        if (this.organisation?.hasOwnProperty('profiles')) {
            this._supportData = this.organisation.profiles.filter(profile => profile.type == 'support');
            this._loading = false;
        }
        this._isApproved = this.organisation?.approvalStatus == 'Approved';
        this._isPilot = this.organisation?.pilot;
        this.renderRoot.querySelector('button,a')?.focus();
        cardLinks(this.shadowRoot);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.eventManager.disconnect();
    }
    render() {
        let main = '';
        if (this._loading) {
            main = html `<allin-loader loading></allin-loader>`;
        }
        else {
            let cards = html `<p>No support profiles found for this organisation.</p><a href="javascript:void(0)" @click=${this._handleAddSupportProfileClick} class="button">Add support profile</a>`;
            if (this._supportData?.length) {
                cards = html `\n                    <ul>\n                        ${this._supportData.map((support) => {
                    let name = decodeEntities(support.name);
                    let id = support.id;
                    let in_progress = support.in_progress;
                    let isLocked = support.isLocked;
                    let status = support.approvalStatus ? getStatus(support.approvalStatus) : '';
                    let path = this.organisation.fileURL;
                    let alt = this.organisation.photoAltText;
                    let notices = support.declineMessage ? html `<div class="notices">\n                                    <span class="screen-reader-text">\n                                        ${support.declineMessage ? `You have a notice relating to ${organisation.name}` : ''}\n                                    </span>\n                                    <span aria-hidden="true" >${support.declineMessage ? '1' : ''}</span>\n                                </div>` : '';
                    let buttonGroup = html `\n                                <div class="button-group">\n                                    <a href="javascript:void(0)" data-support_profile_id="${id}" data-org_id="${this.currentOrg}" @click=${this._handleSupportProfileClick}>View support profile</a>\n                                    <a href="javascript:void(0)" data-support_profile_id="${id}" data-org_id="${this.currentOrg}" @click=${this._handleSupportProfileDetailsClick}>Manage details</a>\n                                </div>\n                            `;
                    if (in_progress) {
                        status = `New application in progress`;
                        if (isLocked) {
                            buttonGroup = html `\n                                    <div class="button-group">\n                                        <p >This form is currently being edited by someone else</p>\n                                    </div>\n                                    `;
                        }
                        else {
                            buttonGroup = html `\n                                    <div class="button-group">\n                                        <a href="javascript:void(0)" class="button" @click=${this._handleAddLocationClickContinue} data-locid="${id}" data-ppage="${in_progress}">Complete saved form</a>\n                                    </div>\n                                    `;
                        }
                    }
                    let inlineNotice = '';
                    if (support.approvalStatus == 'Rejected') {
                        inlineNotice = support.declineMessage ? html `<div class="notices">\n                                    <p>${support.declineMessage}</p>\n                                </div>` : '';
                        buttonGroup = '';
                        notices = '';
                    }
                    return html `\n                                <li class="bg support-card card">\n                                    <img src="${path}" alt="${alt}">\n                                    <div class="content">\n                                        <h4>${name}</h4>\n                                        ${status && html `<p>${status}</p>`}\n                                        ${buttonGroup}\n                                        ${inlineNotice}\n                                    </div>\n                                    ${notices}\n                                </li>\n                                `;
                })}\n                    </ul>\n                `;
            }
            main = html `\n                <div class="grid">\n                    <h3>${decodeEntities(this.organisation?.name ?? '')} support profiles</h3>\n                    ${cards}\n                </div>\n            `;
        }
        return html `${main}`;
    }
    _getOrganisationById(id) {
        return this.organisations.find((org) => org.org_id == id);
    }
    _handleAddSupportProfileClick(e) {
        e.preventDefault();
        this._updateContext({ panel: 'add' });
    }
    _handleSupportProfileClick(e) {
        e.preventDefault();
        this._updateContext({ dashboard: 'support', panel: `${e.target.dataset.support_profile_id}`, view: 'read' });
    }
    _handleSupportProfileDetailsClick(e) {
        e.preventDefault();
        this._updateContext({ dashboard: 'support', panel: `${e.target.dataset.support_profile_id}`, view: 'edit' });
    }
    async _handleContextUpdate(value) {
        let currentOrg = this.currentOrg;
        this.organisationData = value;
        ({ currentOrg: this.currentOrg, name: this.name, restUrl: this.restUrl, organisations: this.organisations, action: this.action, nonce: this.nonce, user: this.currentUser, provisions: this.provisions } = this.organisationData);
        this.organisation = this._getOrganisationById(this.currentOrg);
    }
    static styles = [
        accessibility,
        grid,
        css `
        .bg{
            padding:var(--allin-padding,2rem);
            background-color:var(--allin-bg-color,#ccc);
            display:grid;
            gap:1rem;
            margin-bottom:1rem;
            
        }
        @media screen and (min-width:700px){
            .bg{
                grid-template-columns: auto 1fr 2rem;
            }
        }
        .button{
            text-align:center;
        }
        .grid{
            gap:1.5rem;
        }
        
        .card a{
            display:block;
            padding:0rem;
            border-radius:0;
            background-color:transparent;
            color:var(--allin-highlight-color,#472961);
            text-align:center;
            font-weight:700;
            text-decoration:underline;
            transition:color var(--transition) ease;
            height:fit-content;
            align-self:start;
            text-underline-offset: 6px;
        }

        .card:hover a{
            color:var(--allin-highlight-color-lighter,#5e3e7d);
        }

        .card a::after{
            content: "";
            display: inline-block;
            width: 21px;
            height: 15px;
            background: url('/wp-content/themes/ace/assets/arrow.svg') no-repeat center;
            background-size: cover;
            margin-left: 12px;
            transform: translateY(3px);
        }

        .content{
            display:grid;
            gap:0.5rem;
            padding: var(--allin-padding,2rem);
        }
        .content-zones{
            display:grid;
            gap:0.5rem;
            padding: 2rem 0 0;
        }
        .card img{
            object-fit:contain;
        }
        .bg.card.support-card {
            padding: 0;
        }
        .card.support-card img {
            object-fit: cover;
            width: 260px;
            height: 100%;
            aspect-ratio: 1;
        }
        h4,h3,p{
            margin:0;
        }

        .button-group{
            display:flex;
            /* justify-content:space-between; */
            gap:0.7rem;
            flex-direction: column;
        }

        .button-group button svg{
            transition:transform var(--transition) ease;
        }
        .button-group button:hover, .return:hover{
            text-decoration-thickness:2px;
        }
        
        .button-group button:hover svg, .return:hover svg{
            transform:rotate(15deg);
        }
    
        ul{
            list-style:none;
            padding:0;
            margin:0;
        }

        ul li{
            display:grid;
            gap:0.5rem;
        }

        .button{
            padding:1rem;
            border-radius:var(--allin-border-radius,0.5rem);
            font-family:var(--allin-font-family,'Montserrat');
            background-color:var(--allin-button-bg-color,#472961);
            font-size:var(--allin-button-font-size,1rem);
            color:var(--allin-button-text-color,#fff);
            font-weight:(var(--allin-button-font-weight,600));
            cursor:pointer;
            border:none;
            text-decoration:none;
            transition:background-color var(--transition) ease;
        }

        ul.zone-list li{
            grid-template-columns: 1fr auto;
            border-top: 1px solid gray;
            border-bottom: 1px solid gray;
            padding: 0.5rem 0;
            font-weight: bold;

        }
        ul.zone-list li .message{
            grid-row: 2 / 3;
            grid-column: 1 / -1;
            font-weight: 400;
        }
        ul.zone-list li a {
            justify-self: end;
            font-size: 0.9rem;
        }
        ul.zone-list li a::after{
            content: none;
            background: none;
        }
        

        `
    ];
}
